import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import SearchContent from '../components/SearchContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';

class Search extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title={"Search Products: "+this.props.params.word} slug={this.props.params.id} />
                <SearchContent category={this.props.params.id} search_word={this.props.params.word}  />  
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(Search);;